/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="jdbcUrl" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="driverClassName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="connectionProperties" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Jdbc extends MoserObject{

	jdbcUrl = null;

	driverClassName = null;

	connectionProperties = null;



	/**
	 * Gets the value of the jdbcUrl property.
	 * @return {String} possible object is {@link String}
	 */
	getJdbcUrl() {
		return this.jdbcUrl;
	}

	/**
	 * Sets the value of the jdbcUrl property.
	 * @param {String} value allowed object is {@link String}
	 */
	setJdbcUrl(value) {
		var oldValue = this.jdbcUrl;
		this.jdbcUrl = value;
		this._setAndNotify(131, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the driverClassName property.
	 * @return {String} possible object is {@link String}
	 */
	getDriverClassName() {
		return this.driverClassName;
	}

	/**
	 * Sets the value of the driverClassName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDriverClassName(value) {
		var oldValue = this.driverClassName;
		this.driverClassName = value;
		this._setAndNotify(132, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the connectionProperties property.
	 * @return {String} possible object is {@link String}
	 */
	getConnectionProperties() {
		return this.connectionProperties;
	}

	/**
	 * Sets the value of the connectionProperties property.
	 * @param {String} value allowed object is {@link String}
	 */
	setConnectionProperties(value) {
		var oldValue = this.connectionProperties;
		this.connectionProperties = value;
		this._setAndNotify(133, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Jdbc</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Jdbc</code> object from.
	 * @return {Jdbc} an object of type <code>Jdbc</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createJdbc();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Jdbc";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 131, "jdbcUrl", null));
		featureList.push(this.createFeature(false, false, false, 132, "driverClassName", null));
		featureList.push(this.createFeature(false, false, false, 133, "connectionProperties", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 131:
			this.setJdbcUrl((value));
			break;
		case 132:
			this.setDriverClassName((value));
			break;
		case 133:
			this.setConnectionProperties((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 131:
			return this.getJdbcUrl();
		case 132:
			return this.getDriverClassName();
		case 133:
			return this.getConnectionProperties();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 131:
			return this.getJdbcUrl();
		case 132:
			return this.getDriverClassName();
		case 133:
			return this.getConnectionProperties();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Jdbc.js